module.exports = __webpack_public_path__ + "img/personal-account.9b10e2d.webp";